// dashboard/src/hooks/useApiKeys.ts
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createApiKey, listApiKeys, revokeApiKey, ApiKey, ApiKeyCreateResponse } from '../services/apiKeyService';

export const useApiKeys = () => {
  return useQuery<ApiKey[], Error>({
    queryKey: ['apiKeys'],
    queryFn: listApiKeys,
  });
};

export const useCreateApiKey = () => {
  const queryClient = useQueryClient();
  
  return useMutation<ApiKeyCreateResponse, Error, { keyName?: string }>({
    mutationFn: ({ keyName }) => createApiKey(keyName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
    },
  });
};

export const useRevokeApiKey = () => {
  const queryClient = useQueryClient();
  
  return useMutation<void, Error, { keyId: string }>({
    mutationFn: ({ keyId }) => revokeApiKey(keyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
    },
  });
};
